import { useMutation, useQueryClient } from "@tanstack/react-query";
import TenantAPI from "../../api/TenantAPI";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import Cookies from "js-cookie";
import API from "../../api/API";

interface Props {
  formID: string;
  tenantID: string;
  payload: any;
  onSuccess: () => void;
  onError: (err: string) => void;
}

const useSubmitPublicForm = () => {
  const client = useQueryClient();

  const submitForm = useMutation({
    mutationFn: async ({ formID, tenantID, payload }: Props) => {
      let user: any;

      return new Promise(async (res, rej) => {
        if (Cookies.get("authenticationToken")) {
          try {
            user = client.getQueryData(["user", tenantID]);

            if (!user) {
              const data = await API.getUser();
              user = data?.data?.data?.user;
              client.setQueryData(["user", tenantID], user);
            }
          } catch {}
        }

        // Don't user user if they aren't in the cloud this form was created in.
        if (
          user &&
          !user?.Tenants?.find((t: any) => t?.TenantID === tenantID)
        ) {
          user = null;
        }

        TenantAPI.createRecordWithForm(formID, tenantID, payload, user?._id)
          .then((data) => res(data.data.data.data))
          .catch((e) => rej(e));
      });
    },
    onSuccess: (_, { onSuccess }) => {
      onSuccess();
    },
    onError: (err, { onError }) => {
      const error = getErrorMessage(err);
      onError(error);
    },
  });

  return {
    submitForm: submitForm.mutate,
    submittingForm: submitForm.isPending,
    submitError: submitForm.error ? getErrorMessage(submitForm.error) : null,
  };
};

export default useSubmitPublicForm;
